import {
  Box,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import React, { useCallback, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { yupResolver } from "@hookform/resolvers/yup";

import ForgotPasswordMessage from "../../../../utils/Enums";
import useMutate from "../../../../hooks/useMutate";
import { updateUserDetails } from "../../../../sevices/apiUser";
import { RFHTextField } from "../../../../components/RFH";
import {
  changePasswordSchema,
  passwordRegex,
} from "../../../../schemas/changePasswordSchema";
import { CustomButton } from "../../../../components/Button/Button";
import { PassWordRequirement } from "../../../../components/ChangePassword/index.js";

function ChangePassword({ userId, onClose }) {
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });
  const { handleSubmit, watch, ...methods } = useForm({
    resolver: yupResolver(changePasswordSchema),
    defaultValues: {},
  });
  const password = watch("password") || "";
  const { mutate, isPending } = useMutate(updateUserDetails, [], () => {},onClose);

  const handleSubmitChangePassword = useCallback(
    (data) => {
      mutate({ userId: userId, data: { password: data.password } });
    },
    [mutate, userId]
  );

  function onError(errors) {
    console.log(errors);
  }

  const requirements = ForgotPasswordMessage.REQUIREMENTS;
  const passWordRegexList = Object.values(passwordRegex);

  const allRequirementsMent = passWordRegexList
    .map((regex) => regex.test(password))
    .every((validation) => validation);

  const handleClickShowPassword = useCallback((newpassword) => {
    if (newpassword === "password") {
      setShowPassword((prev) => ({ ...prev, password: !prev.password }));
    }
    if (newpassword === "ConfirmPassword") {
      setShowPassword((prev) => ({
        ...prev,
        confirmPassword: !prev.confirmPassword,
      }));
    }
  }, []);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <Box
          component="form"
          onSubmit={handleSubmit(handleSubmitChangePassword, onError)}
          noValidate
          // className="submitForm-box"
          className="change-password-form"
        >
          <Typography
            className="user-forgot-password-para"
            component={"h1"}
            variant="h5"
          >
            {ForgotPasswordMessage.CREATE_NEW_PASSWORD_MESSAGE}
          </Typography>
          
          <PassWordRequirement password={password} />

          <RFHTextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="New Password"
            type={showPassword.password ? "text" : "password"}
            id="password"
            autoComplete="current-password"
            defaultPadding={false}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleClickShowPassword("password")}
                    edge="end"
                    aria-label="toggle password visibility"
                  >
                    {showPassword.password ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <RFHTextField
            margin="normal"
            required
            fullWidth
            name="confirmpassword"
            label="Confirm New Password"
            type={showPassword.confirmPassword ? "text" : "password"}
            id="confirmpassword"
            defaultPadding={false}
            autoComplete="current-password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleClickShowPassword("ConfirmPassword")}
                    edge="end"
                    aria-label="toggle password visibility"
                  >
                    {showPassword.confirmPassword ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Stack direction={"row"} justifyContent={"end"} className="mt-2">
            <CustomButton
              type="submit"
              fullWidth
              variant="contained"
              className="btn-blue capitalize change-password-form-update-button"
              disabled={isPending || !allRequirementsMent}
            >
              Update
            </CustomButton>
            <CustomButton
              variant="outlined"
              className="change-password-form-cancel-button"
              onClick={onClose}
            >
              Cancel
            </CustomButton>
          </Stack>
        </Box>{" "}
      </FormProvider>
    </React.Fragment>
  );
}

export default React.memo(ChangePassword);
